var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media"},[_c('EntryTableEditor',{ref:"view",attrs:{"contentTypeId":_vm.contentTypeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }